export enum ModelsEnum {
  IDEAL = 'b6cbebad-22de-46f3-9100-76ad958f598c',
  COMPROMISE = 'b6cbebad-22de-46f3-9100-76ad958f598d'
}
